module.exports = __webpack_public_path__ + "img/type1-bg4.8a3dbfe1.png";